export enum TerminalType {
  BusTerminal = 'BusTerminal', // Bussiterminaali
  TramTerminal = 'TramTerminal', // Ratikkaterminaali
  MetroTerminal = 'MetroTerminal', // Metroterminaali
  RailwayStation = 'RailwayStation', // Juna-asema
  FerryTerminal = 'FerryTerminal', // Laivaterminaali
  FerryStation = 'FerryStation', // Lautta-asema
}
